// import arabic from './lang/arabic';
// import armenianEastern from './lang/armenianEastern';
// import armenianWestern from './lang/armenianWestern';
// import assamese from './lang/assamese';
// import balochi from './lang/balochi';
// import belarusian from './lang/belarusian';
// import bengali from './lang/bengali';
// import brazilian from './lang/brazilian';
// import burmese from './lang/burmese';
// import chinese from './lang/chinese';
// import czech from './lang/czech';
// import farsi from './lang/farsi';
// import french from './lang/french';
// import georgian from './lang/georgian';
// import german from './lang/german';
// import gilaki from './lang/gilaki';
// import greek from './lang/greek';
// import hebrew from './lang/hebrew';
// import hindi from './lang/hindi';
// import hungarian from './lang/hungarian';
// import italian from './lang/italian';
// import japanese from './lang/japanese';
// import kannada from './lang/kannada';
// import korean from './lang/korean';
// import kurdish from './lang/kurdish';
// import macedonian from './lang/macedonian';
// import malayalam from './lang/malayalam';
// import nigerian from './lang/nigerian';
// import nko from './lang/nko';
// import norwegian from './lang/norwegian';
// import odia from './lang/odia';
// import polish from './lang/polish';
// import punjabi from './lang/punjabi';
// import russian from './lang/russian';
// import russianOld from './lang/russianOld';
// import sindhi from './lang/sindhi';
// import spanish from './lang/spanish';
// import swedish from './lang/swedish';
// import telugu from './lang/telugu';
// import thai from './lang/thai';
// import turkish from './lang/turkish';
// import ukrainian from './lang/ukrainian';
// import urdu from './lang/urdu';
// import urduStandard from './lang/urduStandard';
// import uyghur from './lang/uyghur';

import english from './lang/english';

export const keyboardLayouts = [
  // arabic,
  // armenianEastern,
  // armenianWestern,
  // assamese,
  // balochi,
  // belarusian,
  // bengali,
  // brazilian,
  // burmese,
  // chinese,
  // czech,
  english,
  // farsi,
  // french,
  // georgian,
  // german,
  // gilaki,
  // greek,
  // hebrew,
  // hindi,
  // hungarian,
  // italian,
  // japanese,
  // kannada,
  // korean,
  // kurdish,
  // macedonian,
  // malayalam,
  // nigerian,
  // nko,
  // norwegian,
  // odia,
  // polish,
  // punjabi,
  // russian,
  // russianOld,
  // sindhi,
  // spanish,
  // swedish,
  // telugu,
  // thai,
  // turkish,
  // ukrainian,
  // urdu,
  // urduStandard,
  // uyghur,
];
